import { HIDDEN_INDUSTRIES } from '@/config/constants';
import { useMemo } from 'react';
import { usePlan } from './usePlan';

/**
 * The industry allowlist sent to get_entity as the Algolia `industry:` facet.
 * Returns the user's plan industries minus internal/experimental ones, or null
 * when none remain (so callers send no facet rather than an empty one). Shared
 * by the assistant chat and the report build path so both resolve the same set
 * of entities — the report path previously sent null, letting hidden industries
 * (e.g. "manipulation") leak into resolved reports.
 */
const useSearchableIndustries = () => {
    const { industry: planIndustries } = usePlan();
    return useMemo(() => {
        if (!planIndustries?.length) return null;
        const visible = planIndustries.filter(
            (name) => !HIDDEN_INDUSTRIES.includes(name),
        );
        return visible.length ? visible : null;
    }, [planIndustries]);
};

export default useSearchableIndustries;
